import { useOpenState } from '../../internal/components/options-list/utils/use-open-state';
import { fireCancelableEvent, isPlainLeftClick } from '../../internal/events';
import { KeyCode } from '../../internal/keycode';
import { getItemTarget, isItemGroup, isLinkItem } from './utils';
import useHighlightedMenu from './use-highlighted-menu';
export function useButtonDropdown(_a) {
    var items = _a.items, onItemClick = _a.onItemClick, onItemFollow = _a.onItemFollow, hasExpandableGroups = _a.hasExpandableGroups, _b = _a.isInRestrictedView, isInRestrictedView = _b === void 0 ? false : _b, usingMouse = _a.usingMouse;
    var _c = useHighlightedMenu({
        items: items,
        hasExpandableGroups: hasExpandableGroups,
        isInRestrictedView: isInRestrictedView
    }), targetItem = _c.targetItem, isHighlighted = _c.isHighlighted, isExpanded = _c.isExpanded, highlightItem = _c.highlightItem, moveHighlight = _c.moveHighlight, expandGroup = _c.expandGroup, collapseGroup = _c.collapseGroup, reset = _c.reset;
    var _d = useOpenState({ onClose: reset }), isOpen = _d.isOpen, closeDropdown = _d.closeDropdown, toggleDropdown = _d.toggleDropdown;
    var onGroupToggle = function (item) { return (!isExpanded(item) ? expandGroup(item) : collapseGroup()); };
    var onItemActivate = function (item, event) {
        var details = {
            id: item.id || 'undefined',
            href: item.href,
            external: item.external,
            target: getItemTarget(item)
        };
        if (onItemFollow && item.href && isPlainLeftClick(event)) {
            fireCancelableEvent(onItemFollow, details, event);
        }
        if (onItemClick) {
            fireCancelableEvent(onItemClick, details, event);
        }
        closeDropdown();
    };
    var doVerticalNavigation = function (direction) {
        if (isOpen) {
            moveHighlight(direction);
        }
    };
    var openAndSelectFirst = function (event) {
        toggleDropdown();
        moveHighlight(1);
        event.preventDefault();
    };
    var actOnParentDropdown = function (event) {
        // if there is no highlighted item we act on the trigger by opening or closing dropdown
        if (!targetItem) {
            if (isOpen && !isInRestrictedView) {
                toggleDropdown();
            }
            else {
                openAndSelectFirst(event);
            }
        }
        else {
            if (isItemGroup(targetItem)) {
                onGroupToggle(targetItem, event);
            }
            else {
                onItemActivate(targetItem, event);
            }
        }
    };
    var activate = function (event, isEnter) {
        usingMouse.current = false;
        // if item is a link we rely on default behavior of an anchor, no need to prevent
        if (targetItem && isLinkItem(targetItem) && isEnter) {
            return;
        }
        event.preventDefault();
        actOnParentDropdown(event);
    };
    var onKeyDown = function (event) {
        switch (event.keyCode) {
            case KeyCode.down: {
                doVerticalNavigation(1);
                event.preventDefault();
                break;
            }
            case KeyCode.up: {
                doVerticalNavigation(-1);
                event.preventDefault();
                break;
            }
            case KeyCode.space: {
                // Prevent scrolling the list of items and highlighting the trigger
                usingMouse.current = false;
                event.preventDefault();
                break;
            }
            case KeyCode.enter: {
                activate(event, true);
                break;
            }
            case KeyCode.left:
            case KeyCode.right: {
                if (targetItem && isItemGroup(targetItem) && !isExpanded(targetItem)) {
                    expandGroup();
                }
                else if (hasExpandableGroups) {
                    collapseGroup();
                }
                event.preventDefault();
                break;
            }
            case KeyCode.escape: {
                closeDropdown();
                event.preventDefault();
                break;
            }
            case KeyCode.tab: {
                closeDropdown();
                break;
            }
        }
    };
    var onKeyUp = function (event) {
        // We need to handle activating items with Space separately because there is a bug
        // in Firefox where changing the focus during a Space keydown event it will trigger
        // unexpected click events on the new element: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        if (event.keyCode === KeyCode.space) {
            activate(event);
        }
    };
    return {
        isOpen: isOpen,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        toggleDropdown: toggleDropdown
    };
}
//# sourceMappingURL=use-button-dropdown.js.map